import { render, staticRenderFns } from "./GRadioButtonsForm.vue?vue&type=template&id=b0cfa80c&"
import script from "./GRadioButtonsForm.vue?vue&type=script&lang=ts&"
export * from "./GRadioButtonsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports